import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdSearch, MdModeEdit, MdDelete } from "react-icons/md";

export class FoodLibraryTable extends Component {
    render() {
        const columns = [
            {
                Header: "Name",
                accessor: "name",
            },
            {
                Header: "Calories",
                id: "nutrients",
                accessor: "nutrients",
                Cell: (row) => <span>{row.value.map((e) => (e.key === "calories" ? e.value : null))}</span>,
            },
        ];

        const { match, fetching, data, error, filterData, selectRow, pages, page, pageSize, deleteFoodItem, viewFoodsLibrary, setPageNumber, setPageSize, showModal } = this.props;

        const actions = [
            {
                name: "view",
                // btnText: "View",
                btnAction: viewFoodsLibrary,
                btnClass: "btn-success",
                btnIcon: MdSearch,
                hiddenParam: "hasPassed",
                tooltip: "View",
            },
            {
                name: "edit",
                // btnText: "Edit",
                btnAction: selectRow,
                btnClass: "btn-primary",
                btnIcon: MdModeEdit,
                tooltip: "Edit",
            },
            {
                name: "delete",
                // btnText: "Delete",
                btnAction: showModal,
                btnClass: "btn-danger",
                btnIcon: MdDelete,
                tooltip: "Delete",
            },
        ];

        return (
            <div>
                <Card className="pp4">
                    <CardHeader>Food items</CardHeader>

                    <CardBody>
                        {error && <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>}
                        <DataTable
                            columns={columns}
                            loading={fetching}
                            manual={true}
                            pages={pages}
                            page={page}
                            pageSize={pageSize}
                            urlParams={match}
                            data={data ? data.data : []}
                            count={data ? data.count : 0}
                            defaultPageSize={5}
                            deleteRow={deleteFoodItem}
                            selectRow={selectRow}
                            viewFoodsLibrary={viewFoodsLibrary}
                            filterData={filterData}
                            setPageNumber={setPageNumber}
                            setPageSize={setPageSize}
                            searchParam="searchKey"
                            //hideSearchParam={true}
                            searchPlaceholder="Search by name"
                            actions={actions}
                        />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default FoodLibraryTable;
